import React from "react";
import { IProduct } from "../../../../classes/interfaces";
import { formatBRL } from "../../../../helpers/currency.helper";
import Photo from "../../../../components/ui/Photo";
import { Card, ThumbWrap, Info, Title, Description, Footer, PriceBlock, Price, OldPrice, ActionPill } from "./DesktopCard.styles";

interface DesktopProductCardProps {
  product: IProduct;
  qty: number;
  onOpen: (product: IProduct) => void;
  /** Cardápio-vitrine (/menu): sem o botão de adicionar; o card só abre os detalhes. */
  readOnly?: boolean;
}

export default function DesktopProductCard({ product, qty, onOpen, readOnly = false }: DesktopProductCardProps) {
  const hasPromo = !!product.promotionalPrice && product.promotionalPrice > 0;

  return (
    <Card onClick={() => onOpen(product)}>
      <ThumbWrap>
        <Photo src={product.imageUrl} radius={14} />
      </ThumbWrap>
      <Info>
        <Title>{product.name}</Title>
        {product.description && <Description>{product.description}</Description>}
        <Footer>
          <PriceBlock>
            {hasPromo && <OldPrice>de {formatBRL(product.price)}</OldPrice>}
            <Price>{formatBRL(hasPromo ? product.promotionalPrice : product.price)}</Price>
          </PriceBlock>
          {!readOnly && (
            <ActionPill
              type="button"
              $active={qty > 0}
              aria-label={`Adicionar ${product.name}`}
              onClick={(e) => {
                e.stopPropagation();
                onOpen(product);
              }}
            >
              {qty > 0 ? `${qty} no carrinho` : "Adicionar"}
            </ActionPill>
          )}
        </Footer>
      </Info>
    </Card>
  );
}
